import {
  DeclarationPaymentStatusTranslations,
  EIIState,
  ZEBRA_ALLOWED_PRINT_STATES,
} from '@shared';
import { InternationalInvoiceDeclarationInfo, PaymentCostsInfo } from '@models';

export function isZebraPrintAvailable(state: EIIState): boolean {
  return ZEBRA_ALLOWED_PRINT_STATES.includes(state);
}

export function getServicesForPaymentStatusCheck(paymentCostsInfo: PaymentCostsInfo): number[] {
  const {
    Services,
    AfterPayment,
    MoneyTransfer,
    Commission,
    AfterPaymentCommission,
    InternationalDelivery,
    Return,
    Redirecting,
    CustomsPayments,
    CustomsBrokerageClearance,
  } = paymentCostsInfo ?? {};

  return [
    Services,
    AfterPayment,
    MoneyTransfer,
    Commission,
    AfterPaymentCommission,
    InternationalDelivery,
    Return,
    Redirecting,
    CustomsPayments,
    CustomsBrokerageClearance,
  ];
}

export function getPaidServicesForPaymentStatusCheck(paymentCostsInfo: PaymentCostsInfo): number[] {
  const {
    ServicesPaid,
    AfterPaymentPaid,
    MoneyTransferPaid,
    CommissionPaid,
    AfterPaymentCommissionPaid,
    InternationalDeliveryPaid,
    ReturnPaid,
    RedirectingPaid,
    CustomsPaymentsPaid,
    CustomsBrokerageClearancPeaid
  } = paymentCostsInfo ?? {};

  return [
    ServicesPaid,
    AfterPaymentPaid,
    MoneyTransferPaid,
    CommissionPaid,
    AfterPaymentCommissionPaid,
    InternationalDeliveryPaid,
    ReturnPaid,
    RedirectingPaid,
    CustomsPaymentsPaid,
    CustomsBrokerageClearancPeaid,
  ];
}

export function isSomeServicePaid(services: number[]): boolean {
  return services.some(service => service !== 0);
}

export function getDeclarationsTooltip(declarations: InternationalInvoiceDeclarationInfo[]): string {
  return declarations
    .map(
      (declaration) =>
        `Декларація ${declaration.DeclarationNumber}: ${DeclarationPaymentStatusTranslations[
          declaration.PaymentStatus
          ].toLowerCase()}`,
    )
    .join('\n');
}
